module.exports = __webpack_public_path__ + "static/animation-e70c09ba14fc0c2ced5ad14f5ef75b6b.webm";